import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

import { getImagesByQuery } from './js/pixabay-api.js';
import { createGallery, clearGallery, showLoader, hideLoader } from './js/render-functions.js';

const form = document.querySelector('.form');

form.addEventListener('submit', event => {
  event.preventDefault();

  const query = event.currentTarget.elements['search-text'].value.trim();

  if (query === '') {
    iziToast.warning({ 
        message: 'Please enter a search query!',
        position: 'topRight' 
    });
    return;
  }

  clearGallery();
  showLoader();

  getImagesByQuery(query)
    .then(data => {
      if (data.hits.length === 0) {
        iziToast.error({
          message: 'Sorry, there are no images matching your search query. Please try again!',
          position: 'topRight',
          backgroundColor: '#ef4040', 
          messageColor: '#fff',      
          maxWidth: 432,              
          progressBarColor: '#ffbebe',     
          displayMode: 'once',
          close: true,
           theme: 'dark',              
    messageSize: '16px',
    layout: 2,
        });
        return;
      }
      createGallery(data.hits);
    })
    .catch(error => {
      iziToast.error({ 
          message: 'Something went wrong. Please try again later.',
          position: 'topRight',
          backgroundColor: '#ef4040',
          messageColor: '#fff',
      });
      console.log(error);
    })
    .finally(() => {
      hideLoader();
      event.target.reset();
    });
});